import React from 'react';
import MeusPedidos from '../MeusPedidos';

const Dashboard: React.FC = () => {
  return <MeusPedidos />;
};

export default Dashboard;
